module.exports = __webpack_public_path__ + "8f0901fb89f7a3f6c5273c201981aa6f.jpg";